import { useEffect, useState } from "react";
import useThemeHook from "../hooks/useThemeHook";
import { useTranslationHook } from "../hooks/useTranslationHook";
import { THEME_COLORS } from "../themes/DarkLight";
import emitter, { EmitterEvents } from "../utils/eventsEmitter";
import isRunningOnMobile from "../utils/isRunningOnMobile";
import { useNavigate } from "react-router-dom";
import CommonButton from "./CommonButton";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { title } from "process";
import {
  GitBranchOutline,
  LockOpenOutline,
  PersonOutline,
} from "react-ionicons";
import { PAGE_NAME, User } from "../../types";
import { getDiffInDaysFromDates } from "../utils/getDiffInDaysFromDates";
import arthereumProvider from "../../backend/ArthereumProvider";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../redux";
import { TransactionsHistory } from "../pages/history/HistoryPage";
import Text from "./ThemedText";
import { FONTSIZE } from "../../constants";
import EasterEggModal from "./EasterEggModal";
import LoadingIndicator from "../components/LoadingIndicator";
import ContestPointsModal from "./ContestPointsModal";
import PreGrantAdModal from "./PreGrantAdModal";
import ViralShareModal from "./ViralShareModal";
const calculateUnstakeAmount = (
  initialAmount: number,
  stakeDaysLeft: number,
  stakeDurationInDays: number = 30
): any => {
  if (stakeDaysLeft <= stakeDurationInDays - 10) {
    console.log("hum");

    return 0; // No return if unstaked after 10 days of staking
  }

  const penaltyFactor = Math.pow(stakeDaysLeft / stakeDurationInDays, 2); // Quadratic penalty
  console.log(stakeDaysLeft);

  console.log(penaltyFactor);

  const maxReturn = initialAmount / 2; // Maximum return is half of the initial amount

  const unstakeAmount = maxReturn * (1 - penaltyFactor); // Apply penalty to max return

  return Math.max(unstakeAmount, 0)?.toFixed(4); // Ensure non-negative return
};
export default function GlobalModalsDisplayer() {
  const [element, setElement] = useState<any>(null);
  const userData = useSelector((state: any) => state?.actualUser);

  const onBottomSheetDisplay = ({
    modal,
  }: {
    modal: { name: string; modalData?: any };
  }) => {
    if (modal?.name === "alertModal") {
      setElement(
        <AlertModal modalData={modal.modalData} closeModal={closeModal} />
      );
    } else if (modal?.name === "stake") {
      setElement(
        <StakeModal modalData={modal.modalData} closeModal={closeModal} />
      );
    } else if (modal?.name === "userModal") {
      setElement(
        <UserModal modalData={modal.modalData} closeModal={closeModal} />
      );
    } else if (modal?.name === "adsModal") {
      setElement(
        <EasterEggModal closeModal={closeModal} userData={userData} />
      );
    } else if (modal?.name === "contestPointsModal") {
      setElement(
        <ContestPointsModal closeModal={closeModal} modalData={modal.modalData} />
      );
    } else if (modal?.name === "preGrantAdModal") {
      setElement(
        <PreGrantAdModal
          closeModal={closeModal}
          onClaim={modal.modalData.onClaim}
          grantAmount={modal.modalData.grantAmount}
        />
      );
    } else if (modal?.name === "viralShareModal") {
      setElement(
        <ViralShareModal
          closeModal={closeModal}
          grantAmount={modal.modalData.grantAmount}
          multiplier={modal.modalData.multiplier}
        />
      );
    } else {
      return null;
    }
  };
  const closeModal = () => {
    setElement(null);
  };

  useEffect(() => {
    emitter.addListener(
      EmitterEvents.BOTTOM_SHEET_DISPLAY,
      onBottomSheetDisplay
    );
    return () => {
      emitter.removeListener(EmitterEvents.BOTTOM_SHEET_DISPLAY);
    };
  }, [onBottomSheetDisplay]);
  const theme = useThemeHook();
  const getTranslationText = useTranslationHook();

  if (!element) return null;
  return (
    <div onClick={closeModal} className="overlay">
      <div
        onClick={(e) => e.stopPropagation()}
        style={{ backgroundColor: THEME_COLORS[theme].full_theme }}
        className="ModalBottomSheet hide-scrollbars"
      >
        <div
          style={{
            height: "100%",
            display: "flex",
            width: "100%",
            flexDirection: "column",
            justifyContent: "flex-start",
          }}
        >
          {isRunningOnMobile() && (
            <div
              style={{
                marginBottom: "20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
              }}
            >
              <div
                style={{
                  backgroundColor: THEME_COLORS[theme].less_theme,
                  marginBottom: "20px",
                }}
                className="bottomStyling"
              >
                {" "}
              </div>
            </div>
          )}
          <div
            style={{
              flexGrow: 1,
              overflow: "auto",
              msOverflowStyle: "none", // Hide scrollbars in IE and Edge
              scrollbarWidth: "none", // Hide scrollbars in Firefox
            }}
            className="hide-scrollbars"
          >
            {element}
          </div>
          <div
            style={{
              flexGrow: 0,
              position: "sticky",
              bottom: 0,
              padding: "10px 0",
            }}
          >
            <CommonButton
              text={getTranslationText("cancel")}
              onClickHandle={closeModal}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

const UserModal = ({
  closeModal,
  modalData,
}: {
  closeModal: Function;
  modalData: {
    user: User;
  };
}) => {
  const theme = useThemeHook();
  const getTranslationText = useTranslationHook();
  console.log(modalData);

  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const userData = useSelector((state: any) => state?.actualUser);
  const navigate = useNavigate();
  const sendCrypto = () => {
    closeModal();
    setTimeout(() => {
      navigate(PAGE_NAME.SEND_CRYPTO, {
        state: { userToSend: modalData.user },
      });
    }, 300);
  };
  return (
    <>
      <div
        style={{
          display: "flex",
          height: "100%",
          justifyContent: "space-between",
          alignItems: "center",
          flexDirection: "column",
          paddingBottom: 30,
        }}
      >
        <PersonOutline
          color={THEME_COLORS[theme].piPurple}
          height={"50px"}
          width={"50px"}
        />
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            justifyContent: "center",
            gap: "10px",
            padding: "10px",
          }}
        >
          <p
            style={{
              fontWeight: "bold",
              fontSize: "25px",
              color: THEME_COLORS[theme].inverse_theme,
              textAlign: "center",
            }}
          >
            {modalData.user?.username}
          </p>
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            gap: "16px",
            marginBottom: "16px",
          }}
        >
          <div
            onClick={() => {
              window.open(
                "https://profiles.pinet.com/profiles/" +
                  modalData?.user?.username,
                "_blank"
              );
            }}
            style={{
              flex: 1,
              padding: "16px",
              backgroundColor: THEME_COLORS[theme].component_background_color,
              borderRadius: "16px",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
            }}
          >
            <Text
              text={getTranslationText("view_profile")}
              style={{
                fontSize: FONTSIZE.QUATERNARY,
                fontWeight: "500",
                opacity: 0.9,
              }}
            ></Text>
            <Text
              style={{ fontSize: FONTSIZE.SIXTERNARY }}
              text={"Pi Profile"}
            ></Text>
          </div>

          <div
            onClick={sendCrypto}
            style={{
              flex: 1,
              padding: "16px",
              backgroundColor: THEME_COLORS[theme].component_background_color,
              borderRadius: "16px",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
            }}
          >
            <div
              style={{
                fontSize: FONTSIZE.QUATERNARY,
                color: THEME_COLORS[theme].inverse_theme,
                fontWeight: "500",
                opacity: 0.9,
              }}
            >
              {getTranslationText("send_crypto_to", {
                name: modalData?.user?.username,
              })}
            </div>
          </div>
        </div>
        <TransactionsHistory withUserId={modalData?.user?.id} />
      </div>
    </>
  );
};
const StakeModal = ({
  closeModal,
  modalData,
}: {
  closeModal: Function;
  modalData: {
    stakeBoost: any;
    piAmountStaked: any;
    createdAt: any;
    unstaked: any;
    endsAt: any;
    id: any;
  };
}) => {
  const theme = useThemeHook();
  const getTranslationText = useTranslationHook();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const userData = useSelector((state: any) => state?.actualUser);

  // Calculate days remaining (negative if already ended)
  const endsAt = new Date(modalData?.endsAt);
  const now = new Date();
  const timeDiff = endsAt.getTime() - now.getTime();
  const daysLeft = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
  
  // Stake has ended if daysLeft <= 0
  const hasStakeEnded = daysLeft <= 0;
  
  // Can unstake if:
  // 1. Not already unstaked AND
  // 2. Either stake has ended (no penalty) OR there are >= 20 days left (minimal penalty)
  const canUnstake = !modalData?.unstaked && (hasStakeEnded || daysLeft >= 20);
  
  // For display purposes, show 0 if negative
  const displayDaysLeft = Math.max(0, daysLeft);

  const unstake = async () => {
    if (!canUnstake || isLoading) {
      return;
    }
    
    setIsLoading(true);
    try {
      const user = await arthereumProvider.unstake(
        modalData?.id,
        userData?.user?.id
      );
      dispatch(actions.setActualUser(user));
      
      emitter.emit(EmitterEvents.BOTTOM_SHEET_DISPLAY, {
        modal: {
          name: "alertModal",
          modalData: {
            description: getTranslationText("unstake_success_desc", {
              amount: modalData.stakeBoost,
              newBoost: user?.user?.stakeBoost,
            }),
            title: getTranslationText("unstake_success", {
              amount: calculateUnstakeAmount(
                modalData?.piAmountStaked,
                daysLeft
              ),
              crypto: "Pi",
            }),
            icon: (
              <LockOpenOutline
                color={THEME_COLORS[theme].piPurple}
                height={"50px"}
                width={"50px"}
              />
            ),
          },
        },
      });
      emitter.emit(EmitterEvents.UNSTAKE);
    } catch (error) {
      alert(getTranslationText("error"));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          height: "100%",
          justifyContent: "space-between",
          alignItems: "center",
          flexDirection: "column",
          paddingBottom: 30,
        }}
      >
        <GitBranchOutline
          color={THEME_COLORS[theme].piPurple}
          height={"50px"}
          width={"50px"}
        />
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            justifyContent: "center",
            gap: "10px",
            padding: "10px",
          }}
        >
          <p
            style={{
              fontWeight: "bold",
              fontSize: "25px",
              color: THEME_COLORS[theme].inverse_theme,
              textAlign: "center",
            }}
          >
            x
            {getTranslationText("Boost_amount", {
              amount: modalData?.stakeBoost?.toFixed(2),
            })}
          </p>
          {modalData?.unstaked === true ? (
            <p
              style={{
                textAlign: "center",
                fontWeight: "normal",
                fontSize: "15px",
                color: THEME_COLORS[theme].red,
              }}
            >
              {getTranslationText("unstaked", { days: displayDaysLeft })}
            </p>
          ) : (
            <>
              <p
                style={{
                  textAlign: "center",
                  fontWeight: "normal",
                  fontSize: "15px",
                  color: THEME_COLORS[theme].inverse_theme,
                }}
              >
                {hasStakeEnded
                  ? "Stake ended"
                  : getTranslationText("stake_days_left", { days: displayDaysLeft })}
              </p>
              <p
                style={{
                  textAlign: "center",
                  fontWeight: "normal",
                  fontSize: "15px",
                  color: canUnstake
                    ? THEME_COLORS[theme].green
                    : THEME_COLORS[theme].orange,
                }}
              >
                                {canUnstake?"Can unstake":"Penality for unstaking"}

              </p>
            </>
          )}
        </div>

        {isLoading && <LoadingIndicator />}
        {canUnstake && !modalData?.unstaked && (
          <CommonButton
            text={getTranslationText("unstake_for", {
              amount: calculateUnstakeAmount(
                modalData?.piAmountStaked,
                daysLeft
              ),
              crypto: "Pi",
            })}
            backgroundColor={THEME_COLORS[theme].piPurple}
            onClickHandle={unstake}
            textColor="white"
          />
        )}
      </div>
    </>
  );
};
const AlertModal = ({
  closeModal,
  modalData,
}: {
  closeModal: Function;
  modalData: {
    title: string;
    description: string;
    icon?: any;
    customButton?: {
      id: "deposit";
      title?: string;
      textColor?: string;
      bgColor?: string;
    };
  };
}) => {
  const theme = useThemeHook();
  const getTranslationText = useTranslationHook();
  const navigate = useNavigate();

  const handleCustomButtonType = () => {
    closeModal();
    switch (modalData?.customButton?.id) {
      case "deposit":
        navigate(PAGE_NAME.DEPOSIT, { state: { crypto: {} } });
        break;
      default:
        break;
    }
  };
  return (
    <>
      <div
        style={{
          display: "flex",
          height: "100%",
          justifyContent: "space-between",
          alignItems: "center",
          flexDirection: "column",
          paddingBottom: 30,
        }}
      >
        {modalData.icon}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            justifyContent: "center",
            gap: "10px",
            padding: "10px",
          }}
        >
          <p
            style={{
              fontWeight: "bold",
              fontSize: "25px",
              color: THEME_COLORS[theme].inverse_theme,
              textAlign: "center",
            }}
          >
            {modalData.title}
          </p>
          <p
            style={{
              textAlign: "center",
              fontWeight: "normal",
              fontSize: "15px",
              color: THEME_COLORS[theme].inverse_theme,
            }}
          >
            {modalData.description}
          </p>
        </div>
        {modalData?.customButton && (
          <CommonButton
            text={
              modalData?.customButton?.title ?? getTranslationText("cancel")
            }
            backgroundColor={modalData?.customButton?.bgColor ?? undefined}
            onClickHandle={handleCustomButtonType}
          />
        )}
      </div>
    </>
  );
};
